<template>
  <App :key="appComponentKey"></App>
</template>

<script>
import { mapState } from 'vuex';
import App from '@/views/shared/App.vue';

export default {
  components: {
    App,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['appComponentKey']),
  },
};
</script>
